angular.module('zc.zenclerkS')
  .component('zcsCampaignSummary', {
    bindings: {
      campaign: '<',
      project: '<'
    },
    templateUrl: '/templates/zenclerk_s/sites/campaigns/show/summary.html',
    controller: zcsCampaignSummaryController,
  });


zcsCampaignSummaryController.$inject = ['$filter', '$q', '$scope', '$state', '$uibModal', '$translate', 'Campaign', 'CampaignStatsV2', 'Incentive', 'SearchFilter', 'ZcsAccessStats', 'ZcsCampaign', 'ZcsCampaignStats', 'currencies'];
function zcsCampaignSummaryController($filter, $q, $scope, $state, $uibModal, $translate, Campaign, CampaignStatsV2, Incentive, SearchFilter, ZcsAccessStats, ZcsCampaign, ZcsCampaignStats, currencies) {
  const vm = this;
  const region = vm.project.region;

  const allowedDimensions = {
    hourly: {
      moment: 'hours',
      format: 'YYYY-MM-DD HH:00',
    },
    daily: {
      moment: 'days',
      format: 'YYYY-MM-DD 00:00',
    },
    monthly: {
      moment: 'months',
      format: 'YYYY-MM-DD',
    },
  };

  function isBeginningOfTheMonth(date) {
    return +moment.tz(date, region) === +moment.tz(date, region).startOf('month');
  }

  vm.$onInit = () => {
    let defaultMonth = _.min([$filter('changeDatetimeFrom')('localToRegion', vm.campaign.end_at, 'date', region), moment.tz(region).toDate()]);

    /**
     * Use previous month as the default month filter IF
     *  - the ending date of the campaign is right at the beginning of a month (therefore having no data).
     */
    if(isBeginningOfTheMonth(defaultMonth)) {
      defaultMonth = $filter('changeDatetimeFrom')('localToRegion', vm.campaign.end_at, 'moment', region).subtract(1, 'months').toDate();
    }

    // filter default values
    const filterDefaults = {
      month: {
        default: moment.tz(defaultMonth, region).startOf('month').format('YYYY-MM-DD')
      },
      dimension: {
        default: 'daily'
      },
      main_chart: {
        default: 'conversionPrice'
      }
    };

    vm.firstDataDay = moment.tz(ZcsCampaign.FIST_DATA_DAY, region).toDate();
    vm.firstDataDayInJapanese = moment.tz(vm.firstDataDay, region).format($translate.instant('sites.campaigns.show.summary.yearMonthFormat'));

    vm.filters = SearchFilter.resolveFromLocation();

    SearchFilter.setComponentDefaults('campaignSummary', filterDefaults);

    $scope.$on('$destroy', () => {
      SearchFilter.removeComponentDefaults('campaignSummary');
    });

    vm.totalPeriodStartAt = moment.tz(vm.campaign.start_at, region).startOf('day').valueOf();
    vm.totalPeriodEndAt = vm.campaign.end_at_obj.date > Date.now()
      ? moment.tz(region).startOf('hour').valueOf()
      : vm.campaign.end_at.valueOf();

    vm.currency = currencies[vm.project.currency];
    vm.copyCampaign = copyCampaign;
    vm.isAllowedLiteTemplate = isAllowedLiteTemplate;
    vm.isCampaignEndingSoon = ZcsCampaign.isCampaignEndingSoon;
    vm.campaignProgress = ZcsCampaign.getCampaignProgress(vm.campaign);

    vm.defaultFreeShippingCost = 500;

    vm.goToPeriod = goToPeriod;
    vm.setDimension = setDimension;
    vm.setFreeShippingCost = setFreeShippingCost;

    vm.hasNextMonth = hasNextMonth;
    vm.hasPrevMonth = hasPrevMonth;
    vm.hasReachedTheEnd = hasReachedTheEnd;
    vm.setSelectedChart = setSelectedChart;
    vm.isCurrentMonth = isCurrentMonth;

    vm.isCampaignStartedToday = isCampaignStartedToday;

    vm.resumeCampaign = resumeCampaign;
    vm.getMonthlyConversionPercentage = getMonthlyConversionPercentage;

    vm.invoicesPage = $state.href('zenclerkS.project.invoices', { projectId: vm.project.apikey });

    updateData().then(() => {
      // do this only once
      createMonthlyConversionsChartData();
    });
  };

  function getCampaignStats(dimension, opts = {}) {
    let startAt = opts.start_at || vm.startAt;
    let endAt = opts.end_at || vm.currentEnd;

    if(dimension === 'monthly') {
      startAt = moment.tz(vm.totalPeriodStartAt, region).startOf('month').valueOf();
      endAt = vm.totalPeriodEndAt;
    }

    return ZcsCampaignStats.find({
      apikey: vm.project.apikey,
      dimension: dimension
    }, {
      campaign_id: vm.campaign.id,
      start_at: {
        $gte: startAt,
        $lt: endAt
      }
    });
  }

  function setDimension(dimension) {
    vm.filters.dimension = dimension;
    updateFilters();
  }

  function updateData() {
    vm.startAt = _.max([
      moment.tz(vm.filters.month, region).startOf('month').valueOf(),
      moment.tz(vm.campaign.start_at, region).startOf('day').valueOf(), // TODO: in case of hour...
    ]);
    vm.currentEnd = _.min([
      moment.tz(vm.filters.month, region).endOf('month').valueOf(),
      moment.tz(region).startOf('hour').valueOf()]);

    return Promise.all([
      getCampaignStats(vm.filters.dimension),
      ZcsAccessStats.getAccessStatsForSegment(vm.project.apikey, vm.campaign.segment_id, vm.startAt, vm.currentEnd),
    ])
      .then(([campaignStats, accessStats]) => {
        vm.fetchedCampaignStats = campaignStats;
        vm.fetchedAccessStats = accessStats;
        calculateAllCosts();

        vm.mainChartData = getMainChartData(vm.filters.main_chart, vm.fetchedCampaignStats);
      });

  }

  function calculateAllCosts() {
    vm.segmentStats = {};
    vm.campaignStats = {};

    vm.campaignStats.conversionPrice = _.sumBy(
      vm.fetchedCampaignStats,
      d => d.effective_conversion_price
    );
    vm.campaignStats.conversionCount = _.sumBy(
      vm.fetchedCampaignStats,
      d => d.effective_conversion_count
    );

    if(!vm.campaign.incentives[0].discount_type || vm.campaign.incentives[0].discount_type === 'none') {
      vm.campaignStats.couponCost = vm.campaignStats.conversionCount * (vm.project.free_shipping_cost || vm.defaultFreeShippingCost);
    } else {
      vm.campaignStats.couponCost = _.sumBy(
        vm.fetchedCampaignStats,
        d => d.coupon_cost
      );
    }

    vm.campaignStats.grossMargin = _.sumBy(
      vm.fetchedCampaignStats,
      d => d.effective_conversion_price * d.profit_rate
    );
    vm.campaignStats.salesCost = _.sumBy(
      vm.fetchedCampaignStats,
      d => d.effective_conversion_price * (1 - d.profit_rate)
    );
    vm.campaignStats.zcFeeTaxIncluded = _.sumBy(
      vm.fetchedCampaignStats,
      d => d.zc_fee_tax_included
    );
    vm.campaignStats.campaignProfit = _.sumBy(
      vm.fetchedCampaignStats,
      d => d.profit
    ); // NOTE: not used. Calculated is more correct in case of free_shipping
    vm.campaignStats.campaignProfitCalculated = vm.campaignStats.grossMargin - vm.campaignStats.couponCost - vm.campaignStats.zcFeeTaxIncluded;
    vm.campaignStats.deliveryCount = _.sumBy(
      vm.fetchedCampaignStats,
      d => d.delivery_count
    );
    vm.campaignStats.conversionPercent = (vm.campaignStats.conversionCount / vm.campaignStats.deliveryCount) * 100 || 0;
    vm.campaignStats.averagePurchase = vm.campaignStats.conversionPrice / vm.campaignStats.conversionCount || 0;
    vm.campaignStats.fee_rate = _.get(vm.fetchedCampaignStats, 'fee_rate', vm.project.fee_rate) * 100;

    vm.segmentStats.sessionCount = _.sumBy(
      vm.fetchedAccessStats,
      d => d.session_count
    );
    vm.segmentStats.conversionCount = _.sumBy(
      vm.fetchedaccessStats,
      d => d.conversion_count
    );
    vm.segmentStats.conversionPrice = _.sumBy(
      vm.fetchedaccessStats,
      d => d.conversion_price
    );
    vm.segmentStats.conversionPercent = (vm.segmentStats.conversionCount / vm.segmentStats.sessionCount) * 100;
    vm.segmentStats.averagePurchase = vm.segmentStats.conversionPrice / vm.segmentStats.conversionCount;
    vm.segmentStats.campaignDeliveryPercent = (vm.campaignStats.deliveryCount / vm.segmentStats.sessionCount) * 100;
  }

  function setSelectedChart(chartType) {
    if(vm.filters.main_chart !== chartType) {
      vm.filters.main_chart = chartType;
      updateFilters();
    }
  }

  function updateFilters() {
    SearchFilter.set(vm.filters);
    SearchFilter.updateComponentDefaults('campaignSummary');
    updateData();
  }

  function goToPeriod(month, direction) {
    if(direction === 'prev') {
      if(!hasPrevMonth()) return;
      vm.filters.month = moment.tz(month, region).subtract(1, 'month').format('YYYY-MM-DD');
    } else if(direction === 'next') {
      if(!hasNextMonth()) return;
      vm.filters.month = moment.tz(month, region).add(1, 'month').format('YYYY-MM-DD');
    } else {
      vm.filters.month = moment.tz(month, region).format('YYYY-MM-DD');
    }
    updateFilters();
  }

  function getMainChartData(selectedData, data) {
    if(selectedData === 'conversions') {
      const campaignStatsByDate = _.groupBy(data, d => moment(d.start_at).format('YYYY-MM-DD HH:00'));
      const campaignByDate = generateChartData(vm.filters.dimension, campaignStatsByDate, 'delivery_count', vm.startAt, vm.currentEnd, ['effective_conversion_count']);
      const conversionByDate = generateChartData(vm.filters.dimension, campaignStatsByDate, 'effective_conversion_count', vm.startAt, vm.currentEnd);
      // chart data array
      return [
        {
          values: conversionByDate,
          key: $translate.instant('sites.campaigns.show.summary.cvCount'),
        },
        {
          values: campaignByDate,
          key: $translate.instant('sites.campaigns.show.summary.couponDeliveryCount'),
        },
      ];
    }

    if(selectedData === 'conversionPrice') {
      const campaignStatsByDate = _.groupBy(data, d => moment(d.start_at).format('YYYY-MM-DD HH:00'));
      const conversionPriceByDate = generateChartData(vm.filters.dimension, campaignStatsByDate, 'effective_conversion_price', vm.startAt, vm.currentEnd);
      // chart data array
      return [
        {
          values: conversionPriceByDate,
          key: $translate.instant('sites.campaigns.show.summary.conversionPrice'),
        },
      ];
    }

    if(selectedData === 'conversionPriceCumulative') {
      const campaignStatsByDate = _.groupBy(data, d => moment(d.start_at).format('YYYY-MM-DD HH:00'));
      const conversionPriceByDate = generateChartData(vm.filters.dimension, campaignStatsByDate, 'effective_conversion_price', vm.startAt, vm.currentEnd);

      let total = 0;
      const existingConversionPrice = [];
      _.each(conversionPriceByDate, d => {
        const newItem = _.merge({}, d);
        newItem.y = total;
        total = total + d.y;
        existingConversionPrice.push(newItem);
      });

      // chart data array
      return [
        {
          values: existingConversionPrice,
          key: $translate.instant('sites.campaigns.show.summary.existingConversionPrice'),
        },
        {
          values: conversionPriceByDate,
          key: $translate.instant('sites.campaigns.show.summary.conversionPriceByDate'),
        },
      ];
    }
  }

  function createMonthlyConversionsChartData() {
    $q.all([
      getCampaignStats('monthly'),
    ]).then(([monthlyStats]) => {
      let conversionPriceByDate = _.groupBy(monthlyStats, d => moment(d.start_at).format('YYYY-MM-DD'));
      const conversionParamName = 'effective_conversion_price';
      conversionPriceByDate = generateChartData('monthly', conversionPriceByDate, conversionParamName, vm.totalPeriodStartAt, vm.totalPeriodEndAt);

      vm.maxMonthlyPrice = _.maxBy(conversionPriceByDate, 'y').y;
      vm.monthlyConversionChartData = conversionPriceByDate;
    });
  }

  function hasReachedTheEnd() {
    return moment.tz(vm.filters.month, 'YYYY-MM-DD', region).subtract(1, 'month').isBefore(moment.tz(vm.firstDataDay, region));
  }

  function hasPrevMonth() {
    const maxDate = _.max([
      vm.firstDataDay,
      moment.tz(vm.campaign.start_at, region).startOf('month')]);
    return moment.tz(vm.filters.month, 'YYYY-MM-DD', region).subtract(1, 'month').isSameOrAfter(moment.tz(maxDate, region));
  }

  function hasNextMonth() {
    const maxDate = _.min([moment.tz(region).toDate(), moment.tz(vm.campaign.end_at, region).toDate()]);
    return moment.tz(vm.filters.month, 'YYYY-MM-DD', region).add(1, 'month').isBefore(moment.tz(maxDate, region));
  }

  function generateDateRange(dimension, startAt, endAt) {
    if(!_.has(allowedDimensions, dimension)) {
      console.warn(`Invalid dimension given! Valid dimensions are: ${Object.keys(allowedDimensions).join(', ')}`);
      return;
    }

    const dateRange = [];
    let date = getFirstDate(startAt);
    const lastDate = getLastDate(endAt);
    while(date <= lastDate) {
      dateRange.push(moment.tz(date, region).format(allowedDimensions[dimension].format));
      date = moment.tz(date, region).add(1, allowedDimensions[dimension].moment).valueOf();
    }

    // remove the last month from dateRange if the campaigns ending date is the first day of the month eg. 2017-05-01 00:00
    if(dimension === 'monthly' && isBeginningOfTheMonth(lastDate)) {
      dateRange.pop();
    }

    return dateRange;
  }

  function getFirstDate(startAt) {
    return moment.tz(startAt, region).startOf('month').valueOf();
  }

  function getLastDate(endAt) {
    return moment.tz(endAt, region).endOf('month').valueOf();

  }

  function generateChartData(dimension, dateKeys, paramToBeSummed, startAt, endAt, paramsToBeSubtracted) {
    if(angular.isString(paramsToBeSubtracted)) {
      paramsToBeSubtracted = [paramsToBeSubtracted];
    }

    const dateRange = generateDateRange(dimension, startAt, endAt);

    // generate x and y values for each date in range
    const data = _.map(dateRange, function(dateKey) {
      if(!dateKeys[dateKey]) {
        return { x: moment(dateKey, allowedDimensions[dimension].format).toDate(), y: 0 };
      }

      let y = _.sumBy(dateKeys[dateKey], d => d[paramToBeSummed]);

      // subtract any given parameter values from y value.
      if(paramsToBeSubtracted) {
        _.forEach(paramsToBeSubtracted, subtractParam => {
          y -= _.sumBy(dateKeys[dateKey], d => d[subtractParam]);
        });
      }

      // dont allow negative y values
      if(y < 0) {
        y = 0;
      }
      if(paramToBeSummed !== 'effective_conversion_count' && paramToBeSummed !== 'delivery_count') {
        y = y / 10 ** vm.currency.fractionSize;
      }

      return { x: moment(dateKey, allowedDimensions[dimension].format).toDate(), y: y };
    });
    return data;
  }

  function isCampaignStartedToday() {
    return moment.tz(region).startOf('day').isSame(moment.tz(vm.campaign.start_at, region).startOf('day'));
  }

  // duplicate campaign
  function copyCampaign() {
    const campaignObject = _.merge({}, vm.campaign);

    return Campaign
      .copy({projectId: vm.project.id, campaignId: campaignObject.id}, campaignObject)
      .then(res => $state.go('zenclerkS.project.campaigns.draft', {apikey: vm.project.apikey}, { reload: true }));
  }

  function isAllowedLiteTemplate() {
    return ZcsCampaign.isAllowedLiteTemplate(vm.campaign, vm.project);
  }

  function isCurrentMonth(month) {
    return moment.tz(month, region).isSame(moment.tz(vm.filters.month, 'YYYY-MM', region));
  }

  function getMonthlyConversionPercentage(dataOfMonth = 0) {
    dataOfMonth = dataOfMonth | 0;
    const percentage = dataOfMonth / vm.maxMonthlyPrice * 100;
    const minimumPercentage = 2;

    return percentage < minimumPercentage ? minimumPercentage : percentage;
  }

  function setFreeShippingCost() {
    const modalInstance = $uibModal.open({
      templateUrl: '/templates/zenclerk_s/directives/project/free_shipping_cost_editor/free_shipping_cost_editor.html',
      controller: 'ZcsFreeShippingCostEditorController',
      controllerAs: '$ctrl',
      size: 'sm',
      resolve: {
        project: vm.project
      }
    });

    modalInstance.result.then(() => {
      // update the prices
      calculateAllCosts();
    });
  }

  // toggle campaign state TODO: DRYme into campaign service
  function resumeCampaign() {
    return Campaign.toggleActive({
      projectId: vm.campaign.project_id,
      campaignId: vm.campaign.id,
      state: true
    })
      .then(function(res) {
        if(res.data.success) {
          vm.campaign.status = 'activated';
          let currentStatus = $filter('currentStatus')(vm.campaign);
          vm.campaign.current_status = currentStatus;
          return true;
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/sites/campaigns/show/summary.component.js